export default axios => ({
  /**
   * Возвращает список площадок на модерации
   *
   * @param pageSize
   * @param currentPage
   * @param searchBy
   * @param sort
   * @param order
   * @returns {*}
   */
  list ({ pageSize = 10, currentPage = 1, searchBy = '', sort = 'id', order = 'DESC' } = {}) {
    const params = {
      pageSize: pageSize,
      pageIndex: currentPage,
      search: searchBy,
      sort: sort,
      order: order
    }

    return axios.get('/web/moderation/list', { params })
  },
  /**
   * Возвращает данные площадки
   *
   * @param id
   * @returns {*}
   */
  moderation (id) {
    return axios.get(`/web/moderation/get/${id}`)
  },
  /**
   * Одобряет площадку
   *
   * @param id
   * @returns {*}
   */
  accept (id) {
    return axios.put(`/web/moderation/get/${id}/edit`, {
      status: true
    })
  },
  /**
   * Отклоняет площадку
   *
   * @param id
   * @param comment
   * @returns {*}
   */
  reject ({ id, comment = '' }) {
    return axios.put(`/web/moderation/get/${id}/edit`, {
      status: false,
      comment
    })
  }
})
